// Mapeamento de dados para fornecer conteúdo rico na versão gratuita
// Baseado nos perfis de comunicação identificados

export interface ProfileData {
  id: string;
  name: string;
  description: string;
  strengths: string[];
  growthOpportunities: string[];
  challenges: string[];
  leadershipStyle: string;
  communicationStyle: string;
}

const profileMappings: ProfileData[] = [
  {
    id: 'diplomatica',
    name: 'Diplomática',
    description: 'Comunica-se com empatia e tato, construindo pontes e buscando consenso. Harmoniza ambientes e facilita acordos com sua abordagem ponderada e estratégica.',
    strengths: ['Mediação de Conflitos', 'Escuta Ativa', 'Construção de Consenso', 'Comunicação Interpessoal', 'Visão Estratégica'],
    growthOpportunities: ['Tomada de Decisão Rápida', 'Assertividade em Feedbacks', 'Defesa de Posições Impopulares'],
    challenges: [],
    leadershipStyle: 'Liderança Democrática e Facilitadora, com forte inclinação para o estilo Transformacional. Inspira e desenvolve a equipe através da construção de consenso e parcerias estratégicas, mantendo a autoridade e a visão de longo prazo.',
    communicationStyle: 'Ponderada, empática e estratégica.',
  },
  {
    id: 'tecnica',
    name: 'Técnica',
    description: 'Valoriza a precisão e a lógica. Sua comunicação é baseada em dados, fatos e argumentos bem estruturados, trazendo clareza e objetividade para as discussões.',
    strengths: ['Análise Crítica', 'Raciocínio Lógico', 'Comunicação Estruturada', 'Resolução de Problemas', 'Atenção a Detalhes'],
    growthOpportunities: ['Comunicação Interpessoal', 'Flexibilidade a Novas Ideias', 'Síntese para Públicos não Técnicos'],
    challenges: [],
    leadershipStyle: 'Liderança Especialista e Meritocrática. A autoridade emana da competência técnica e do rigor analítico. Foca em planejamento detalhado, métricas mensuráveis e otimização de processos, valorizando a eficiência e os resultados baseados em evidências.',
    communicationStyle: 'Precisa, lógica e baseada em dados.',
  },
  {
    id: 'visionaria',
    name: 'Visionária',
    description: 'Pinta quadros do futuro com suas palavras, inspirando e motivando todos ao redor. Sua paixão e clareza de propósito mobilizam equipes em direção a grandes objetivos.',
    strengths: ['Comunicação Inspiradora', 'Storytelling', 'Pensamento Criativo', 'Liderança Carismática', 'Visão de Longo Prazo'],
    growthOpportunities: ['Atenção a Detalhes de Execução', 'Pés no Chão', 'Escuta de Feedbacks Críticos'],
    challenges: [],
    leadershipStyle: 'Liderança Transformacional e Carismática. Mobiliza e inspira equipes através de uma visão clara e de um propósito significativo. Utiliza storytelling e apelo emocional para engajar stakeholders e promover uma cultura de inovação e criatividade.',
    communicationStyle: 'Inspiradora, apaixonada e focada no futuro.',
  },
  {
    id: 'colaborativa',
    name: 'Colaborativa',
    description: 'Cria sinergia e um forte senso de equipe. Facilita a participação de todos, valoriza a diversidade de ideias e constrói um ambiente de segurança psicológica.',
    strengths: ['Facilitação de Grupos', 'Trabalho em Equipe', 'Criação de Ambientes Seguros', 'Inclusão', 'Inteligência Emocional'],
    growthOpportunities: ['Assertividade em Defesa de Ideias', 'Gestão de Prazos', 'Confronto Construtivo'],
    challenges: [],
    leadershipStyle: 'Liderança Inclusiva e Participativa. Cria sinergia e um forte senso de equipe ao facilitar a participação de todos e valorizar a diversidade de ideias. Focada em criar um ambiente de segurança psicológica que fomenta a colaboração e o desenvolvimento de talentos.',
    communicationStyle: 'Inclusiva, facilitadora e focada na equipe.',
  },
  {
    id: 'assertiva',
    name: 'Assertiva',
    description: 'Comunica-se de forma direta, clara e confiante. Defende suas posições com firmeza e coragem, impulsionando a ação e a tomada de decisões difíceis.',
    strengths: ['Comunicação Direta', 'Assertividade', 'Coragem', 'Tomada de Decisão', 'Foco em Resultados'],
    growthOpportunities: ['Escuta Ativa', 'Flexibilidade', 'Empatia com Diferentes Pontos de Vista'],
    challenges: [],
    leadershipStyle: 'Liderança Diretiva e Decisiva. Comunica-se de forma direta e clara, impulsionando a ação e a tomada de decisões difíceis. Focada em resultados e performance, não hesita em enfrentar resistência para atingir os objetivos.',
    communicationStyle: 'Direta, clara, confiante e orientada para a ação.',
  },
  {
    id: 'direta',
    name: 'Direta',
    description: 'Comunica-se sem rodeios, com objetividade e foco na resolução. Sua franqueza acelera processos e clareia as expectativas, embora possa ser percebida como insensível.',
    strengths: ['Comunicação Objetiva', 'Franqueza', 'Foco em Soluções', 'Eficiência', 'Clareza de Expectativas'],
    growthOpportunities: ['Desenvolver a Escuta Ativa', 'Adaptar a Comunicação para cada Público', 'Exercitar a Paciência'],
    challenges: ['Pode ser percebida como rude ou insensível', 'Dificuldade em situações que exigem mais tato', 'Pode gerar retração em interlocutores mais sensíveis'],
    leadershipStyle: 'Liderança Autoritária e Focada em Resultados. Valoriza a rapidez e a eficiência, tomando decisões de forma centralizada. A comunicação é um instrumento para garantir que as metas sejam atingidas sem desvios.',
    communicationStyle: 'Extremamente direta, objetiva e sem rodeios.',
  },
  {
    id: 'criativa',
    name: 'Criativa',
    description: 'Enxerga além do óbvio, conectando ideias de formas inesperadas. Sua comunicação é original e cheia de insights, abrindo portas para a inovação.',
    strengths: ['Pensamento Divergente', 'Originalidade', 'Geração de Ideias', 'Resolução Criativa de Problemas', 'Intuição'],
    growthOpportunities: ['Foco em Execução', 'Comunicação Estruturada', 'Análise de Viabilidade'],
    challenges: [],
    leadershipStyle: 'Liderança Inovadora e Inspiradora. Enxerga além do óbvio, conectando ideias de formas inesperadas para abrir portas à inovação. Lidera através de insights originais e da capacidade de inspirar equipes a explorar novas possibilidades.',
    communicationStyle: 'Original, perspicaz e não convencional.',
  },
  {
    id: 'perfeccionista',
    name: 'Perfeccionista',
    description: 'Busca a excelência em cada detalhe. Sua comunicação é rigorosa, bem preparada e orientada para a qualidade, garantindo que os mais altos padrões sejam atingidos.',
    strengths: ['Atenção a Detalhes', 'Busca por Qualidade', 'Planejamento Meticuloso', 'Rigor Analítico', 'Organização'],
    growthOpportunities: ['Delegação de Tarefas', 'Flexibilidade com Prazos', 'Aceitação do "Bom o Suficiente"'],
    challenges: [],
    leadershipStyle: 'Liderança focada em Padrão de Excelência e Instrução. Busca a excelência em cada detalhe, estabelecendo e mantendo os mais altos padrões de qualidade. Lidera pelo exemplo, com uma abordagem rigorosa e meticulosa que garante a qualidade superior.',
    communicationStyle: 'Rigorosa, detalhada e orientada para a qualidade.',
  },
  {
    id: 'relacional',
    name: 'Relacional',
    description: 'Cria conexões autênticas e duradouras. Sua comunicação é empática e focada em construir confiança e um ambiente de apoio mútuo.',
    strengths: ['Construção de Relacionamentos', 'Empatia', 'Networking Autêntico', 'Criação de Confiança', 'Comunicação Interpessoal'],
    growthOpportunities: ['Foco em Metas e Resultados', 'Comunicação em Larga Escala', 'Gestão de Conflitos Diretos'],
    challenges: [],
    leadershipStyle: 'Liderança focada em Conexão e Apoio. Cria conexões autênticas e duradouras, construindo um ambiente de confiança e apoio mútuo. Sua liderança se baseia na força dos relacionamentos e na capacidade de nutrir uma rede de apoio sólida.',
    communicationStyle: 'Empática, autêntica e focada em construir confiança.',
  },
];

export const getProfileData = (profileId: string): ProfileData | undefined => {
  return profileMappings.find((p) => p.id === profileId);
};

export const getAllProfiles = (): ProfileData[] => {
  return profileMappings;
};

/**
 * Retorna os dados completos de um perfil com base no seu nome.
 * @param profileName O nome do perfil (ex: "Assertiva Colaborativa").
 * @returns O objeto ProfileData correspondente ou null se não for encontrado.
 */
export const getProfileDataByName = (profileName: string): ProfileData | null => {
  const profile = profileMappings.find(p => p.name === profileName);
  return profile || null;
};

// Função para gerar descrição baseada no perfil e score
export const generateProfileDescription = (profileName: string, confidenceScore: number): string => {
  const profile = getProfileDataByName(profileName);
  if (!profile) return "";
  
  const confidenceLevel = confidenceScore >= 70 ? "forte" : confidenceScore >= 50 ? "moderada" : "emergente";
  
  return `${profile.description} Com ${confidenceScore}% de aderência, você demonstra uma identificação ${confidenceLevel} com este perfil, indicando que essas características estão bem estabelecidas no seu estilo comunicativo.`;
};

export const getProfileIdByName = (profileName: string): string | null => {
  const profile = profileMappings.find(p => p.name === profileName);
  return profile ? profile.id : null;
};